import type { MembershipSchema } from '@zenid/mypage-api';
import { flex } from '../../../../../../styled-system/patterns';
import { Organization } from '../Organization';

type Props = { memberships: MembershipSchema[] };

export function CurrentOrganizations({ memberships }: Props) {
  return (
    <div
      className={flex({
        border: '1px solid {colors.border.light}',
        borderBottom: 'none',
        borderRadius: '{radii.16} {radii.16} 0 0',
        background: '{gradients.background.gradation}',
        flexDirection: 'column',
      })}
    >
      <div
        className={flex({
          padding: '{spacing.12} {spacing.16}',
          sm: {
            padding: '{spacing.16} {spacing.24}',
          },
        })}
      >
        <h3
          className={flex({
            textStyle: 'headding.xs.regular',
            sm: {
              textStyle: 'headding.s.regular',
            },
          })}
        >
          現在所属している組織
        </h3>
      </div>
      <div
        className={flex({
          flexDirection: 'column',
          backgroundColor: '{colors.background.white}',
        })}
      >
        {memberships.map((membership) => {
          return <Organization key={membership.organization.id} membership={membership} />;
        })}
      </div>
    </div>
  );
}
